const getPreviousSymbol = nMinus => {
  // console.log('nMinus', nMinus)
  if (typeof nMinus !== 'undefined') {
    if (nMinus !== ' ') {
      return nMinus
    }
    return null
  }
  return null
}

const isNumber = str => {
  if (typeof str != 'string') return false
  return !isNaN(str) && !isNaN(parseFloat(str))
}

const noteIsTied = (n1, n2, n3, n4) => {
  if (typeof n1 == 'undefined') return false
  if (n1 === '-') return true
  if (typeof n2 == 'undefined') return false
  if (n1 === '/' && n2 === '-') return true
  
  if (n1 === '2' || n1 === '3' || n1 === '4') {
    if (n2 === '-' ) return true
    if (typeof n3 == 'undefined' && typeof n4 == 'undefined') return false
    if (n2 === '/' && (n3 === '2' || n3 === '3' || n3 === '4') && n4 === '-') return true
  }

  if (typeof n3 == 'undefined') return false

  if (n1 === '/' && (n2 === '2' || n2 === '3' || n2 === '4' || n2 === '8') && n3 === '-') return true

  return false
}

const getNoteLength = (n1, n2, n3, nMinus, prevNote) => {
  if (typeof nMinus !== 'undefined' && prevNote && prevNote === '>') {
    // note is shortened because of a dot
    if (typeof n1 !== 'undefined' && n1 === '/') {
      if (typeof n2 !== 'undefined' && n2 === '2') {
        return {
          symbol: 'd',
          numChars: 3
        }
      } else if (typeof n2 !== 'undefined' && n2 === '4') {
        return {
          symbol: 'h',
          numChars: 3
        }
      }
      return {
        symbol: 's',
        numChars: 3
      }
    }
  } else if (typeof nMinus !== 'undefined' && prevNote && prevNote === '<') {
    // the note is dotted
    if (typeof n1 !== 'undefined' && n1 === '/') {
      if (typeof n2 !== 'undefined' && n2 === '2') {
        return {
          symbol: 'd-q',
          numChars: 3
        }
      } else if (typeof n2 !== 'undefined' && n2 === '4') {
        return {
          symbol: 'd-s',
          numChars: 3
        }
      }
      return {
        symbol: 'd-q',
        numChars: 3
      }
    }

  } else if (typeof n1 !== 'undefined' && n1 === '/') {
    // console.log('>>', n1)
    if (typeof n2 !== 'undefined' && n2 === '2') {
      return {
        symbol: 'q',
        numChars: 3
      }
    } else if (typeof n2 !== 'undefined' && n2 === '4') {
      return {
        symbol: 's',
        numChars: 3
      }
    } else if (typeof n2 !== 'undefined' && n2 === '8') {
      return {
        symbol: 'd',
        numChars: 3
      }
    } else if (typeof n2 !== 'undefined' && typeof n3 !== 'undefined' && n2 === '1' && n3 === '6') {
      return {
        symbol: 'h',
        numChars: 4
      }
    } else if (typeof n2 !== 'undefined' && n2 === '>') {
      return {
        symbol: 'd-q',
        numChars: 3
      }
    } else if (typeof n2 == 'undefined' || !isNumber(n2)) {

      // console.log('symbol: '+ n2)

      if (n2 === '<') {
        // shortened note because of preceeding dotted note
        return {
          symbol: 's',
          numChars: 2
        }
      } else {
        return {
          symbol: 'q',
          numChars: 2
        }
      }
    }
  } else if (typeof n1 !== 'undefined' && isNumber(n1)) { // if a number proceeds the B it's either a long note or a dotted note
    if (typeof n2 !== 'undefined' && n2 === '/') {
      // dotted note
      if (typeof n2 !== 'undefined' && typeof n3 !== 'undefined' && n1 === '3' && n2 === '/' && n3 === '2') {
        return {
          symbol: 'd-c',
          numChars: 4
        }
      }

    } else {
      // long note
      if (n1 === '2') {
        return {
          symbol: 'm',
          numChars: 2
        }
      } else if (n1 === '3') {
        return {
          symbol: 'd-m',
          numChars: 2
        }
      } else if (n1 === '4') {
        return {
          symbol: 'w',
          numChars: 3
        }
      }
      
    }

  } else {
    // else return a crotchet
    return {
      symbol: 'c',
      numChars: 1
    }
  }
}

export const convertAbcToJson = (abcString, globalBeatsPerBar, globalSubdivision) => {

  if (!abcString) return

  let cleanAbc = abcString.replace(/%\d+\n/g, "")
  cleanAbc = cleanAbc.replace(/%\d+/g, "")
  cleanAbc = cleanAbc.replace("  ", " ")

  // TODO: add roll
  cleanAbc = cleanAbc.replace("!roll!", "")

  const rejectSymbols = ['!/////!', 'rBpBat', ':|', '|:', '(4', '(11', 'pppp', 'ffff']

  const hasRejectSymbol = rejectSymbols.some(symbol => cleanAbc.includes(symbol))

  if (hasRejectSymbol) {
    alert('The drum pattern contains illegal symbols')
    return
  }

  let beatsPerBar = globalBeatsPerBar
  let subdivisionPerBar = globalSubdivision

  let bars = []
  let defaultDynamic = 'mp'
  let currentDynamic = defaultDynamic

  let nextnotetie = false
  
  let measures = cleanAbc.split('|')
  measures.pop()
  measures.forEach(bar => {

    let currentMeasure = {}

    let barString = bar

    const timeSignatureMatch = barString.match(/\[M:(\d+)\/(\d+)\]/)
    
    if (timeSignatureMatch) {
      beatsPerBar = parseInt(timeSignatureMatch[1], 10)
      subdivisionPerBar = parseInt(timeSignatureMatch[2], 10)
      barString = barString.replace(/\[M:\d+\/\d+\]/, '')
    }

    currentMeasure.beatsPerBar = beatsPerBar
    currentMeasure.subdivision = subdivisionPerBar
    
    let notes = []
    let i = 0

    let noteCreated = false
    let currentNote = {}
    let previousSymbol = null

    let tupletCount = false
    let tuplet = false

    let tupletNoteCount = 0

    while (i < barString.length) {

      // console.log('barString: '+i, barString)
      
      if (noteCreated) {
        currentNote = {}
        noteCreated = false
      }
      
      let lengthToRemove = 0

      const char = barString[i]

      switch (char) {
        case ' ':
          // console.log('gap')
          i += 1
          break
        
        case '!':
          // dynamic markings
          lengthToRemove = 0
          if (barString.substring(i, i + 3) === '!>!') {
            currentNote.accent = true
            lengthToRemove += 3
          } else if (barString.substring(i, i + 5) === '!ppp!') {
            currentDynamic = 'ppp'
            lengthToRemove = 5
          } else if (barString.substring(i, i + 4) === '!pp!') {
            currentDynamic = 'pp'
            lengthToRemove = 4
          } else if (barString.substring(i, i + 3) === '!p!') {
            currentDynamic = 'p'
            lengthToRemove = 3
          } else if (barString.substring(i, i + 4) === '!mp!') {
            currentDynamic = 'mp'
            lengthToRemove = 4
          } else if (barString.substring(i, i + 4) === '!mf!') {
            currentDynamic = 'mf'
            lengthToRemove = 4
          } else if (barString.substring(i, i + 3) === '!f!') {
            currentDynamic = 'f'
            lengthToRemove = 3
          } else if (barString.substring(i, i + 4) === '!ff!') {
            currentDynamic = 'ff'
            lengthToRemove = 4
          } else if (barString.substring(i, i + 5) === '!fff!') {
            currentDynamic = 'fff'
            lengthToRemove = 5
          }

          if (lengthToRemove > 0) {
            barString = barString.slice(0, i) + barString.slice(i + lengthToRemove)
            // console.log('dynamics added', barString)
          }

          // rolls
          lengthToRemove = 0
          if (barString.substring(i, i + 6) === '!////!') {
            currentNote.roll = 16
            lengthToRemove = 6
          } else if (barString.substring(i, i + 5) === '!///!') {
            currentNote.roll = 8
            lengthToRemove = 5
          } else if (barString.substring(i, i + 4) === '!//!') {
            currentNote.roll = 4
            lengthToRemove = 4
          } else if (barString.substring(i, i + 3) === '!/!') {
            currentNote.roll = 2
            lengthToRemove = 3
          } else if (barString.substring(i, i + 6) === '!buzz!') {
            // TODO buzz rolls
            currentNote.buzz = true
            lengthToRemove = 6
          }

          if (lengthToRemove > 0) {
            barString = barString.slice(0, i) + barString.slice(i + lengthToRemove)
            // console.log('roll added', barString)
          }

          // crescendos
          lengthToRemove = 0
          if (barString.substring(i, i + 4) === '!<(!') {
            lengthToRemove = 4
          } else if (barString.substring(i, i + 4) === '!<)!') {
            lengthToRemove = 4
          }

          if (lengthToRemove > 0) {
            barString = barString.slice(0, i) + barString.slice(i + lengthToRemove)
            // console.log('crescendo (TODO!)', barString)
          }

          break

        case '{':
          lengthToRemove = 0
          if (barString.substring(i, i + 4) === '{/B}') {
            lengthToRemove = 4
            currentNote.flam = true
          } else if (barString.substring(i, i + 3) === '{B}') {
            lengthToRemove = 3
            currentNote.flam = true
          } else if (barString.substring(i, i + 4) === '{BB}') {
            lengthToRemove = 4
            currentNote.drag = true
          } else if (barString.substring(i, i + 5) === '{BBB}') {
            lengthToRemove = 5
            currentNote.ruff = true
          }
          if (lengthToRemove > 0) {
            barString = barString.slice(0, i) + barString.slice(i + lengthToRemove)
            // console.log('grace note added', barString)
          }

          break
          
        case '(':
          // (3
          lengthToRemove = 0
          if (barString.substring(i, i + 6) === '(3:2:4') {
            tuplet = 'triplet'
            tupletCount = 1
            lengthToRemove = 6
            tupletNoteCount = 4
          } 
          else if (barString.substring(i, i + 2) === '(3') {
            tuplet = 'triplet'
            tupletCount = 1
            lengthToRemove = 2
            tupletNoteCount = 3
          } 
          else if (barString.substring(i, i + 2) === '(5') {
            tuplet = 'quintuplet'
            tupletCount = 1
            lengthToRemove = 2
            tupletNoteCount = 5
          }
          else if (barString.substring(i, i + 2) === '(6') {
            tuplet = 'sextuplet'
            tupletCount = 1
            lengthToRemove = 2
            tupletNoteCount = 6
          } 
          else if (barString.substring(i, i + 2) === '(7') {
            tuplet = 'septuplet'
            tupletCount = 1
            lengthToRemove = 2
            tupletNoteCount = 7
          } 
          else if (barString.substring(i, i + 2) === '(9') {
            tuplet = 'nontuplet'
            tupletCount = 1
            lengthToRemove = 2
            tupletNoteCount = 9
          } 
          else if (barString.substring(i, i + 6) === '(6:4:6') {
            tuplet = 'sextuplet'
            tupletCount = 1
            lengthToRemove = 6
            tupletNoteCount = 6
          } 
          else if (barString.substring(i, i + 6) === '(5:4:5') {
            tuplet = 'quintuplet'
            tupletCount = 1
            lengthToRemove = 6
            tupletNoteCount = 5
          }
          else if (barString.substring(i, i + 6) === '(7:4:7') {
            tuplet = 'septuplet'
            tupletCount = 1
            lengthToRemove = 6
            tupletNoteCount = 7
          }
          else if (barString.substring(i, i + 6) === '(9:4:9') {
            tuplet = 'nontuplet'
            tupletCount = 1
            lengthToRemove = 6
            tupletNoteCount = 9
          }

          if (lengthToRemove > 0) {
            barString = barString.slice(0, i) + barString.slice(i + lengthToRemove)
          }

          break 
        
        case 'B':
          previousSymbol = getPreviousSymbol(barString[i - 1])
          
          let noteLength = getNoteLength(barString[i + 1], barString[i + 2], barString[i + 3], barString[i - 1], previousSymbol)

          if (nextnotetie) {
            currentNote.rest = true
            nextnotetie = false
          }
        
          if (noteLength) {

            if (currentNote?.roll && currentNote.roll > 0) {
              // if current note is a roll
            } else if (noteIsTied(barString[i + 1], barString[i + 2], barString[i + 3])) {
              nextnotetie = true
              currentNote.tie = true
            }
            
            if (tuplet) {
              console.log('tupletNoteCount', tupletNoteCount)
              if (tuplet === 'triplet' && tupletCount <= tupletNoteCount) {
                currentNote.length = '3-' + noteLength.symbol
                tupletCount++
                if (tupletCount > tupletNoteCount) {
                  tupletCount = 0
                  tuplet = false
                }
              } 
              else if (tuplet === 'quintuplet' && tupletCount <= tupletNoteCount) {
                currentNote.length = '5-' + noteLength.symbol
                tupletCount++
                if (tupletCount > tupletNoteCount) {
                  tupletCount = 0
                  tuplet = false
                }
              }
              else if (tuplet === 'sextuplet' && tupletCount <= tupletNoteCount) {
                currentNote.length = '6-' + noteLength.symbol
                tupletCount++
                if (tupletCount > tupletNoteCount) {
                  tupletCount = 0
                  tuplet = false
                }  
              } 
              else if (tuplet === 'septuplet' && tupletCount <= tupletNoteCount) {
                currentNote.length = '7-' + noteLength.symbol
                tupletCount++
                if (tupletCount > tupletNoteCount) {
                  tupletCount = 0
                  tuplet = false
                }
              }
              else if (tuplet === 'nontuplet' && tupletCount <= tupletNoteCount) {
                currentNote.length = '9-' + noteLength.symbol
                tupletCount++
                if (tupletCount > tupletNoteCount) {
                  tupletCount = 0
                  tuplet = false
                }
              }
            } else {
              currentNote.length = noteLength.symbol
            }
            
            notes.push(currentNote)
            noteCreated = true
            i += noteLength.numChars
          }
          
          break
        case 'z':
          previousSymbol = getPreviousSymbol(barString[i - 1])
          let restLength = getNoteLength(barString[i + 1], barString[i + 2], barString[i + 3], barString[i - 1], previousSymbol)
          if (restLength) {
            currentNote.rest = true

            if (tuplet) {
              if (tuplet === 'triplet' && tupletCount <= tupletNoteCount) {
                currentNote.length = '3-' + restLength.symbol
                tupletCount++
                if (tupletCount > tupletNoteCount) {
                  tupletCount = 0
                  tuplet = false
                }
              }
              else if (tuplet === 'quintuplet' && tupletCount <= tupletNoteCount) {
                currentNote.length = '5-' + restLength.symbol
                tupletCount++
                if (tupletCount > tupletNoteCount) {
                  tupletCount = 0
                  tuplet = false
                }
              }
              else if (tuplet === 'sextuplet' && tupletCount <= tupletNoteCount) {
                currentNote.length = '6-' + restLength.symbol
                tupletCount++
                if (tupletCount > tupletNoteCount) {
                  tupletCount = 0
                  tuplet = false
                }  
              }
              else if (tuplet === 'septuplet' && tupletCount <= tupletNoteCount) {
                currentNote.length = '7-' + restLength.symbol
                tupletCount++
                if (tupletCount > tupletNoteCount) {
                  tupletCount = 0
                  tuplet = false
                }  
              }
              else if (tuplet === 'nontuplet' && tupletCount <= tupletNoteCount) {
                currentNote.length = '9-' + restLength.symbol
                tupletCount++
                if (tupletCount > tupletNoteCount) {
                  tupletCount = 0
                  tuplet = false
                }  
              } 
            } else {
              currentNote.length = restLength.symbol
            }

            notes.push(currentNote)
            noteCreated = true
            i += restLength.numChars
          }
          break
        default:
          i += 1
          break 
      }

      currentNote.dynamic = currentDynamic

      if (currentNote?.length) {
        // console.log(currentNote)
      }

    }

    // notes
    currentMeasure.notes = notes
    
    bars.push(currentMeasure)

    // console.log('currentMeasure', currentMeasure)

  })

  return {
    "measures": bars
  }
}